package com.taocent.simple.compose.component.blockrichtext.internal.block.renderer

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.taocent.simple.compose.component.blockrichtext.BlockState
import com.taocent.simple.compose.component.blockrichtext.ExperimentalBlockRichTextApi
import com.taocent.simple.compose.component.blockrichtext.TextBlock
import com.taocent.simple.compose.component.blockrichtext.internal.block.TextBlockItem
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockKind
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockRenderer
import kotlin.reflect.KClass

@OptIn(ExperimentalBlockRichTextApi::class)
class TextBlockRenderer(
    private val focusRequesterProvider: (blockId: String) -> androidx.compose.ui.focus.FocusRequester
) : BlockRenderer<TextBlock> {

    override val kind: BlockKind get() = BlockKind.TEXT

    override val blockClass: KClass<TextBlock>
        get() = TextBlock::class

    @Composable
    override fun Render(
        block: TextBlock,
        blockState: BlockState,
        modifier: Modifier
    ) {
        val focusRequester = focusRequesterProvider(block.id)
        TextBlockItem(
            block = block,
            blockState = blockState,
            focusRequester = focusRequester,
            modifier = modifier,
        )
    }
}
